import { Link } from 'expo-router';
import { SafeAreaView, StyleSheet, View } from 'react-native';

import { Button, IconShoppingBag, tokens } from '@fhs/ui';
import { Text } from '@fhs/ui';
import { ADD_MORE_ITEMS_BUTTON, CART_PAGE } from '@fhs-legacy/frontend/src/utils/test-ids';

export function CartEmptyState() {
  return (
    <View testID={CART_PAGE} style={styles.page}>
      <View style={styles.container}>
        <IconShoppingBag size={80} color={tokens.colors.$blackOpacity10} />
        <Text.Ui size="lg" weight="semibold" style={styles.text}>
          Your cart is empty
        </Text.Ui>
        <Text.Ui size="md" style={styles.text}>
          Explore our delicious menu to find the perfect options to add to your cart!
        </Text.Ui>
      </View>
      <SafeAreaView>
        <View style={styles.safeViewContainer}>
          <Link href="/menu" asChild>
            <Button
              testID={ADD_MORE_ITEMS_BUTTON}
              size="xl"
              type="outline"
              accessibilityLabel="Add items to cart"
            >
              <Button.Text>Add Items</Button.Text>
            </Button>
          </Link>
        </View>
      </SafeAreaView>
    </View>
  );
}

const styles = StyleSheet.create({
  page: {
    backgroundColor: 'white',
    borderTopColor: tokens.colors.$black10,
    borderTopWidth: 1,
    flex: 1,
  },
  text: {
    textAlign: 'center',
  },
  container: {
    paddingHorizontal: 32,
    gap: 8,
    flex: 1,
    minHeight: 372,
    alignItems: 'center',
    justifyContent: 'center',
  },

  safeViewContainer: {
    borderTopWidth: 1,
    borderTopColor: tokens.colors.$blackOpacity10,
    width: '100%',
    padding: 16,
  },
});
